<template>
    <div class="card col-12 col-lg-3">
        
        <a :href="item.Url" class="card-content-wrapper card-link-wrapper">
            <div class="card-body card-body-placeholder" v-if="oldItem != null" v-show="!updateCard">
                <div class="card-media">
                    <img class="js-webp no-lazy" :src="placeholderImage" :data-image="placeholderImage" :data-image-webp="placeholderImage" :alt="oldItem.ImageAltText" />
                </div>
                <div class="card-body-content-wrapper">
                    <div class="card-tag" v-if="oldItem.RecipeTypes.length > 0">
                        <span class="article-tag">{{oldItem.RecipeTypes[0].Text}}</span>
                    </div>

                    <p class="card-title">{{oldItem.Title}}</p>
                </div>
            </div>
            <div class="card-body zoom-in" v-show="updateCard">
                <div class="card-media">
                    <img class="js-webp no-lazy zoom-in-img" @load="setLoadedImageState" :src="image" :data-image="image" :data-image-webp="image" :alt="item.ImageAltText" />
                </div>
                <div class="card-body-content-wrapper">
                    <div class="card-tag" v-if="item.RecipeTypes.length > 0">
                        <span class="article-tag">{{item.RecipeTypes[0].Text}}</span>
                    </div>

                    <p class="card-title">{{item.Title}}</p>
                </div>
            </div>
        </a>

    </div>
</template>

<script>
    import imageOptimizer from '../../utils/image-optimizer';
    import {mapState, mapActions, mapMutations} from 'vuex';

	export default {
		props: ['item'],
        data: function () {
	        return {
                updateCard: false,
                oldItem: null,
                oldItemImage: '',
                placeholderImage: ''
            }
        },
		components: {

        },
        computed: {
            ...mapState({
                loadedImages: state => state.listing.loadedImages,
                pageSize: state => state.listing.pagination.pageSize
            }),
            typeTags: function () {
                return this.item.Tags.filter(function (item) {
                    return item.Type.CodeName == 'Types';
                })
            },
            image: function () {
                let html = document.querySelector('html');

                if (html.classList.contains('webp')){
                    if ($(window).width() < 768 && this.item.ImageMobile !== null && this.item.ImageMobile !== undefined && this.item.ImageMobile !== "") {
                        return this.oldItemImage = imageOptimizer.getOptimizedImageUrl(this.item.ImageMobile, 'webp');
                    }
                    else if (this.item.Image !== null && this.item.Image !== "") {
                        return this.oldItemImage = imageOptimizer.getOptimizedImageUrl(this.item.Image);
                    }
                    else {
                        return this.oldItemImage = '../content/images/content-placeholder.webp';
                    }
                }
                else {
                    if ($(window).width() < 768 && this.item.ImageMobile !== null && this.item.ImageMobile !== undefined && this.item.ImageMobile !== "") {
                        return this.oldItemImage = imageOptimizer.getSanitizeMediaUrl(this.item.ImageMobile);                    
                    }
                    else if (this.item.Image !== null && this.item.Image !== "") {
                        return this.oldItemImage = imageOptimizer.getSanitizeMediaUrl(this.item.Image);
                    }
                    else {
                        return this.oldItemImage = '../content/images/content-placeholder.png';
                    }
                }
            }
        },
		mounted: function () {

            this.$store.subscribe((mutation, state) => {
                if (mutation.type === 'listing/setLoadedImageState') {
                    if (this.loadedImages >= this.pageSize - 1)
                    {
                        this.saveItem();
                    }
                }
            });
            this.$store.subscribe((mutation, state) => {
                if (mutation.type === 'listing/updateSpecification') {
                    this.updateCard = false;
                }
            });  
		},
        methods: {
            ...mapMutations('listing', { setLoadedImageState: 'setLoadedImageState' }),
            ...mapMutations('listing', { updateSpecification: 'updateSpecification' }),
            saveItem() {
                this.oldItem = this.item;
                this.updateCard = true;
                //setTimeout(() => { this.updateCard = true; }, 1000);
                setTimeout(() => { this.placeholderImage = this.oldItemImage; }, 500);
            },            
        },
        filters: {
            checkImage: function (value) {
                if (value !== null && value !== "") {
                    return value.replace("~", "");
                }
                else {
                    return "/Content/images/recipe-placeholder.png";
                }
            }
        }
    }
</script>